/* ============
 * Modal Module
 * ============
 */

import state from './state';
import mutations from './mutations';

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/modal/index.js